import styles from './FormDeposit.module.scss'
import { UserInfo, UserInfoType } from 'components/UserInfo/UserInfo'
import { Withdraw } from 'pages/Support/components/Deposit/Withdraw/Withdraw'
import { Icon } from 'components/Icon/Icon'

type Props = {
    data: UserInfoType
}

export function FormDeposit(props: Props) {
    return (
        <div className={styles['container']}>
            <div className={styles['wrapper']}>
                <div className={styles['drizzle_wrapp']}>
                    <div className={styles['drizzle']}>
                        <Icon name='drizzle_preview_mini' />
                    </div>
                    <UserInfo data={props.data} />
                </div>
            </div>
            <div className={styles['bg']}>
                <div className={styles['withdraw']}>
                    <div className={styles['info']}>
                        <span className={styles['title']}>
                            Support me with a Drizzle
                        </span>
                        <span className={styles['description']}>
                            Choose deposit size, and I will get interest
                        </span>
                    </div>
                    <Withdraw onSubmit={() => { }} />
                </div>
            </div>
        </div>
    )
}

